import { DBDef_AdvisorConfiguration, DBDef_EHRInstallation, DBDef_Facility, DBDef_LaunchUrls, DBDef_User, } from '@app/org-shared';
export const views = [
    'general-information',
    DBDef_EHRInstallation.dbKey,
    DBDef_Facility.dbKey,
    DBDef_AdvisorConfiguration.dbKey,
    DBDef_LaunchUrls.dbKey,
    DBDef_User.dbKey
];
export const viewsLabelMap = {
    'general-information': 'General Information',
    'ehr-installations': 'EHR Installations',
    'users': 'Users',
    'environments': 'Environments',
    'advisor-configurations': 'Advisor Configurations',
    'organizations': 'Organizations',
    'facility': 'Facilities',
    'launch-urls': 'Launch Urls',
};
//# sourceMappingURL=types.js.map